import { getBusinessRules } from '../countries/businessRules'

import type {
  CountryDateRulesProfile,
  QueryCountryCode,
} from '@ngb-frontend/shared/types'

/** The country's fully-merged date rules, from the country registry */
export const getCountryDateProfile = (
  countryCode?: QueryCountryCode,
): CountryDateRulesProfile => getBusinessRules(countryCode).dates
